// extracted by mini-css-extract-plugin
export default {"notFound":"_404_notFound__F+Ld5","show":"_404_show__OwAUL"};